






















import { Component, Vue } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class PasswordInstructionWidget extends Vue {
  @Prop({ type: String, default: '100%' }) public maxWidth!: string;
  @Prop({ type: Boolean, default: false }) public dense!: string;

}
